// src/redux/cartSlice.js
import { createSlice } from '@reduxjs/toolkit';

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    services: [],
  },
  reducers: {
    addServiceToCart: (state, action) => {
      const service = action.payload;
      const exists = state.services.find(item => item._id === service._id);
      if (exists) {
        exists.quantity += 1;
      } else {
        state.services.push({ ...service, quantity: 1 });
      }
    },
    removeServiceFromCart: (state, action) => {
      state.services = state.services.filter(item => item._id !== action.payload);
    },
    clearCart: (state) => {
      state.services = [];
    },
    increaseQuantity: (state, action) => {
      const item = state.services.find(s => s._id === action.payload);
      if (item) {
        item.quantity += 1;
      }
    },
    decreaseQuantity: (state, action) => {
      const item = state.services.find(s => s._id === action.payload);
      if (item) {
        if (item.quantity > 1) {
          item.quantity -= 1;
        } else {
          state.services = state.services.filter(s => s._id !== action.payload);
        }
      }
    },
  },
});

export const {
  addServiceToCart,
  removeServiceFromCart,
  clearCart,
  increaseQuantity,
  decreaseQuantity,
} = cartSlice.actions;

export default cartSlice.reducer;
